export const API_CONSTANT = {
  DEFAULT_PROFILE: {
    IMG: "/Image/",
    PDF: "/Pdf/",
    PROFILE: "/commerceProfile",
  },
  INBOX_MESSAGE: {
    COMMAIN_SERVICE: "/ComMainService",
    INBOX_MESS_EP: "/InboxMessage",
    COUNT_UNREAD: "/InboxMessage/count-unread",
    INBOX_READED: `/InboxMessage/readed`,
    INBOX_METEDATA: `/Inquiry/meta-data`,
    INBOX_EXPORTEXCEL: `/InboxMessage/download`,
    GET_BY_ID: `/InboxMessage/get-by-id`,
  },
  INQUIRY_ADMIN: {
    METADATA: "/InquiryManagement/metadata",
    MAIN: "/InquiryManagement",
    EXPORT_EXCEL: "/InquiryManagement/export",
  },
  COMPARE_SERVICE: {
    MAIN_URL: "/CompareService",
    SUB_SERVICE: "/CompareService/sub-service",
  },
  DASHBOARD_STAFF: {
    MAIN_URL: "/DashboardStaff",
    OVERVIEW: "/DashboardStaff/overview",
    EXPORT_EXCEL: "/DashboardStaff/export",
  },
  SEARCH_PAGE: {
    FIRM: "/search-firms",
    SERVICE: "/search-services",
    PRODUCT: "/search-products",
  },
  ADMIN_DASHBOARD: {
    ORGANIZATION: "/admin-firm-management",
    OFFERING: "/admin-service-management",
    INQUIRY_MANAGER: "/inquiry-management",
  },
};

export const FIRM_AVALABILITY_CONSTANT = {
  ACCEPTING_CLIENT: "Accepting client referrals",
  OFFER: "Offer advice/share expertise",
  SHARE_TALENT:
    "Share talent to work on engagements & gain on-the-job training",
  HOST_SHARE_TALENT:
    "Host shared talent to work on engagements & offer on-the-job training",
  OFFER_OPPORTUNITIES: "Offer international secondment opportunities",
};

export const MODAL_CONSTANT = {
  ADD_SERVICE:
    "Select if your organization offers specialized services to showcase to peer organizations for referrals and collaboration.",
  ADD_PRODUCT:
    "Select if you are a member organization or a strategic partner vendor with a product available for purchase (e.g. technology solution).",
  EDIT_SERVICE:
    "Select if your organization offers specialized services to showcase to peer organizations for referrals and collaboration.",
  EDIT_PRODUCT:
    "Select if you are a member organization or a strategic partner vendor with a product available for purchase (e.g. technology solution).",
  ADD_SECONDMENT:
    "This inquiry helps us explore secondment opportunities by understanding your firm’s interest and preferences.",
};

export const MAILL_INFO = {
  CC: ["natasha@allinialglobal.com", "commerce@allinialglobal.com"],
};

export const KEY_ITEM_LOCALSTORAGE = {
  REDIRECT_URL_COMPARE_SERVICE: "rediectURL",
  SELECTED_RECORD_COMPARE_SERVICE: "SelectedRecordCompareService",
};

export const DEFAULT_VALUE = {
  ENTRIES_PER_PAGE: 8,
};

export const FORMAT_DATE = {
  fullDateHyphen: "YYYY-MM-DD",
  fullDateSlash: "YYYY/MM/DD",
  fullDateTimeSlash: "MM/DD/YYYY HH:mm:ss",
  fullDateSlashMonth: "MM/DD/YYYY",
  fullDateSlashMonthSmall: "mm/dd/yyyy",
};

export enum OFFERING_TYPE {
  SERVICE = 1,
  PRODUCT = 2,
  SECONDMENT = 3,
  ORGANIZATION = 4,
}

export enum OFFERING_TYPE_NAME {
  SERVICE = "Service",
  PRODUCT = "Product",
  SECONDMENT = "Secondment",
  ORGANIZATION = "Organization",
}

export enum INQUIRY_MORE_OPTION {
  OTHER = "Other"
}

export const INQUIRY_CONSTANT = {
  BUSINESS_GENERATING_TYPE_ID: {
    YES: 1,
    NO: 2,
    I_DONT_KNOW: 3,
  },

  INQUIRY_STATUS_ID: {
    PENDING: 1,
    WON: 2,
    LOST: 3,
    CANCELLED: 4,
  },

  INQUIRY_TYPE_NAME: {
    INSIDE: "Inside",
    OUTSIDE: "Outside",
  },

  INQUIRY_TYPE_OF_CLIENT_ID: {
    UNKNOWN: 21,
  },
  INQUIRY_TYPE_OF_CLIENT_NAME: {
    UNKNOWN: "Unknown",
  },
};

export const MAIN_SERVICE_CONSTANT = {
  STATUS: {
    PUBLISHED: {
      STATUS_ID: null,
      STATUS_NAME: "Published",
    },
    PENDING_APPROVAL: {
      STATUS_ID: 1,
      STATUS_NAME: "Pending Approval",
    },
    APPROVED: {
      STATUS_ID: 2,
      STATUS_NAME: "Pending Approval",
    },
    PENDING_MODIFICATION: {
      STATUS_ID: 3,
      STATUS_NAME: "Pending Modification",
    },
  },
};

export enum ITEM_LIST_LEVEL {
  SERVICE,
  FIRM,
}

export enum INTEREST_TYPE {
  OFFERING = 1,
  SEEKING = 2,
}

export enum ADMIN_ORGANIZATION {
  ID = 205,
}


export enum ORGANIZATION_TYPE {
  VENDOR = 5,
  strategic_PARTNER = 4,
  MEMBER = 1,
}

export enum SORT_FIELDS_OFFERING_ADMIN {
  SERVICE_NAME = "serviceName",
  FIRM_NAME = "firmName",
  OFFERING_TYPE_ID = "offeringTypeId",
  REGION = "region",
  CREATED_DATE = "createdDate",
  LAST_UPDATE = "lastUpdate",
}

export enum SORT_FIELDS_INQUIRY_ADMIN {
  FROM_ORGANIZATION = "fromOrganization",
  TO_ORGANIZATION = "toOrganization",
  SUBJECT = "subject",
  DATE_TIME = "dateTime",
  STATUS = "status",
  OFFERING_TYPE = "offeringType",
  INQUIRY_TYPE = "inquiryType",
  CREATED_BY = "createdBy",
}

export enum SORT_FIELDS_ORG_ADMIN {
  ORGANIZATION_NAME = "organizationName",
  REGION = "region",
  NUMBER_OF_SERVICES = "numberOfServices",
  NUMBER_OF_PRODUCTS = "numberOfProducts",
  NUMBER_OF_SECONDMENTS = "numberOfSecondments",
}

export enum SORT_FIELDS_OFFERING_DETAIL_ADMIN {
  OFFERING_TYPE = "offeringType",
  OFFERING_NAME = "offeringName",
  REGION = "region",
  CREATED_DATE = "createdDate",
  LAST_UPDATED_DATE = "lastUpdatedDate",
}